<app-dialog
    [dialogWithInput]="dialog">
    <app-create-update-default
            #createUpdateDefaultComponent
        [id]="dialog.input.id"
        [inDialog]="true"
        [hideSaveButton]="true"
        (entityLoaded)="entityLoaded($event)"
        (entitySaved)="entitySaved($event)"
        [buildPayload]="buildPayload"
        [formGroup]="formGroup"
        [service]="service"
        [findOneService]="findByIdService">

        <ng-template template-content>
            <app-card>
                <div class="row">
                    <app-form-field label="Titre" [required]="true" [size]="12">
                        <app-input-text [automaticFocus]="true" [parentFormGroup]="formGroup" parentFormControlName="title"></app-input-text>
                    </app-form-field>
                    <app-form-field label="Description" size="12" *ngIf="dialog.input.id">
                        <app-rich-text-editor [parentFormGroup]="formGroup"
                                              parentFormControlName="initialMessageContentToUpdate"></app-rich-text-editor>
                    </app-form-field>

                    <app-form-field label="Date limite de réalisation" [size]="12">
                        <app-date-picker [parentFormGroup]="formGroup" parentFormControlName="deadline"
                                         style="width: 100%"></app-date-picker>
                    </app-form-field>
                    <app-form-field label="Statut" [required]="true" *ngIf="!dialog.input.statusValue" [size]="12">
                        <app-lov-value-select-filter parentFormControlName="statusValue" [parentFormGroup]="formGroup" lovListName="TASK_STATUS" [lovValueValuesToIgnore]="[TaskStatus.TASK_STATUS_ERROR]"></app-lov-value-select-filter>
                    </app-form-field>
                    <app-form-field label="Assignée à" [size]="12">
                        <app-user-select-filter [parentFormGroup]="formGroup" parentFormControlName="assignedUserId"
                                                style="width: 100%">
                        </app-user-select-filter>
                    </app-form-field>
                    <app-form-field size="12" label="Description" *ngIf="!formGroup.get('summary.id').value">
                        <app-create-message #initialMessage style="width: 100%;"></app-create-message>
                    </app-form-field>
                </div>
            </app-card>
        </ng-template>
    </app-create-update-default>
    <ng-container dialog-actions>
        <app-loading [loading]="createUpdateDefaultComponent.saveLoading" [showText]="false"></app-loading>
        <app-button (click)="executeSave()"
                    [disabled]="!formGroup.valid"
                    fill="solid" size="small"
                    color="primary"
                    label="Enregistrer" *ngIf="!createUpdateDefaultComponent.saveLoading &&
                !createUpdateDefaultComponent.loading && !createUpdateDefaultComponent.findOneError"></app-button>
    </ng-container>
</app-dialog>